import script from "./LegendList.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendList.vue?vue&type=script&setup=true&lang=js"

import "./LegendList.vue?vue&type=style&index=0&id=0c7ed5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7ed5ea"]])

export default __exports__